<template>
  <!-- 웹 버전 버튼 (v-web 디렉티브) -->
  <div v-web class="start-button">
    <!-- 1차 실험: 버튼 위 이미지 요소 (4차 실험에서 추가될 예정) -->
    <div v-if="experiments.buttonImage" class="button-image-container">
      <img :src="experiments.buttonImage.imageUrl" :alt="experiments.buttonImage.alt" />
    </div>

    <div class="price">
      <div class="bigger-price" v-if="biggerPrice > 0">
        {{ addCommaToPrice(biggerPrice) }}
      </div>
      <div class="smaller-price">
        {{ addCommaToPrice(smallerPrice) }}원
      </div>
    </div>

    <!-- 1차 실험: 버튼 컬러가 적용되는 CTA 버튼 -->
    <div
        class="cta"
        :class="[buttonAnimationClass, buttonColorClass]"
        :style="buttonColorStyle"
        @click="handleButtonClick"
    >
      <!-- Neon 애니메이션을 위한 span 요소들 -->
      <span v-if="experiments.buttonAnimation && experiments.buttonAnimation.type === 'neon'" class="neon-border"></span>
      <span v-if="experiments.buttonAnimation && experiments.buttonAnimation.type === 'neon'" class="neon-border"></span>
      <span v-if="experiments.buttonAnimation && experiments.buttonAnimation.type === 'neon'" class="neon-border"></span>
      <span v-if="experiments.buttonAnimation && experiments.buttonAnimation.type === 'neon'" class="neon-border"></span>

      <!-- 3차 실험: 버튼 텍스트 변경 -->
      <span :style="buttonTextStyle">{{ buttonText.main }}</span>
      <span v-if="buttonText.sub"
            :style="buttonSubTextStyle">
        {{ buttonText.sub }}
      </span>
    </div>
  </div>

  <!-- 앱 버전 버튼 (v-app 디렉티브) -->
  <div
      v-app
      v-safe-area-bottom
      class="start-button2"
      :class="[buttonAnimationClass, buttonColorClass]"
      :style="buttonColorStyle"
      @click="handleButtonClick"
  >
    <!-- 4차 실험: 버튼 아이콘 이미지 -->
    <img v-if="experiments.buttonImage" :src="experiments.buttonImage.imageUrl" class="button-icon" />

    <!-- 3차 실험: 앱 버전 텍스트도 실험 적용 -->
    <span :style="buttonTextStyle">{{ buttonText.main || '구매하기' }}</span>

    <span :style="buttonTextStyle" class="original-price2">{{ biggerPrice }}</span>
    <span :style="buttonTextStyle" class="price2">{{ smallerPrice }}</span>

    <!-- 기존 SVG 아이콘 유지 -->
    <svg v-if="!experiments.buttonColor" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.96104 9.96874C8.97418 9.9543 8.98725 9.93979 9.00024 9.9252C9.01323 9.93979 9.02629 9.9543 9.03944 9.96874C9.02629 9.98318 9.01323 9.99769 9.00024 10.0123C8.98725 9.99769 8.97418 9.98318 8.96104 9.96874ZM9.00024 17.238C8.05301 18.3019 6.69307 18.9687 5.18208 18.9687C2.3201 18.9687 0 16.5763 0 13.6252C0 12.2107 0.532967 10.9246 1.40312 9.96874C0.532967 9.01288 0 7.72678 0 6.31232C0 3.36115 2.3201 0.96875 5.18208 0.96875C6.69307 0.96875 8.05301 1.63559 9.00024 2.69943C9.94747 1.63559 11.3074 0.96875 12.8184 0.96875C15.6804 0.96875 18.0005 3.36115 18.0005 6.31232C18.0005 7.72678 17.4675 9.01288 16.5974 9.96874C17.4675 10.9246 18.0005 12.2107 18.0005 13.6252C18.0005 16.5763 15.6804 18.9687 12.8184 18.9687C11.3074 18.9687 9.94747 18.3019 9.00024 17.238Z" fill="#4BD1A9"/>
      <path d="M9.41819 14.1544C8.85656 14.1544 8.33094 14.0572 7.84131 13.8628C7.35169 13.6612 6.92327 13.3839 6.55605 13.0311C6.19603 12.6783 5.91162 12.2679 5.70281 11.7999C5.5012 11.3246 5.40039 10.8134 5.40039 10.2662C5.40039 9.71176 5.5012 9.20053 5.70281 8.73251C5.91162 8.25728 6.19963 7.84326 6.56685 7.49044C6.93407 7.13763 7.35889 6.86401 7.84131 6.6696C8.33094 6.46799 8.85656 6.36719 9.41819 6.36719C9.83581 6.36719 10.239 6.42479 10.6279 6.54C11.0167 6.6552 11.3767 6.81721 11.7079 7.02602C12.0463 7.23483 12.3343 7.48684 12.572 7.78206L11.5135 8.82971C11.2399 8.49129 10.9231 8.23568 10.5631 8.06287C10.2102 7.89006 9.82861 7.80366 9.41819 7.80366C9.07978 7.80366 8.76296 7.86846 8.46774 7.99807C8.17253 8.12048 7.91692 8.29328 7.70091 8.5165C7.4849 8.73251 7.31569 8.99172 7.19328 9.29413C7.07087 9.58935 7.00967 9.91337 7.00967 10.2662C7.00967 10.6118 7.07087 10.9358 7.19328 11.2382C7.31569 11.5334 7.4885 11.7927 7.71171 12.0159C7.93492 12.2319 8.19413 12.4011 8.48935 12.5235C8.79176 12.6459 9.11938 12.7071 9.4722 12.7071C9.86822 12.7071 10.239 12.6243 10.5847 12.4587C10.9303 12.2931 11.2363 12.0555 11.5027 11.7459L12.5287 12.7611C12.2911 13.0491 12.0067 13.2975 11.6755 13.5063C11.3443 13.7152 10.9843 13.8772 10.5955 13.9924C10.2138 14.1004 9.82141 14.1544 9.41819 14.1544Z" fill="#121212"/>
    </svg>
    <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.8184 1C16.6803 1 19 3.39258 19 6.34375C19 7.75879 18.4655 9.04405 17.5947 10C18.4655 10.956 19 12.2412 19 13.6562C19 16.6074 16.6803 19 13.8184 19C12.3069 19 10.9473 18.332 10 17.2676C9.05274 18.3319 7.69302 19 6.18164 19C3.31986 18.9998 1 16.6073 1 13.6562C1.00004 12.2416 1.53387 10.9559 2.4043 10C1.53386 9.04412 1.00005 7.75843 1 6.34375C1 3.39273 3.31986 1.00024 6.18164 1C7.69277 1 9.05276 1.66742 10 2.73145C10.9472 1.66729 12.3071 1.00001 13.8184 1ZM9.95898 10C9.97247 10.0148 9.98667 10.029 10 10.0439C10.0135 10.0288 10.0274 10.014 10.041 9.99902C10.0275 9.98421 10.0133 9.97005 10 9.95508C9.98651 9.97023 9.97264 9.98501 9.95898 10Z" fill="#121212"/>
      <path d="M10.4182 14.1875C9.85656 14.1875 9.33094 14.0903 8.84131 13.8959C8.35169 13.6943 7.92327 13.4171 7.55605 13.0643C7.19603 12.7114 6.91162 12.301 6.70281 11.833C6.5012 11.3578 6.40039 10.8466 6.40039 10.2993C6.40039 9.7449 6.5012 9.23367 6.70281 8.76565C6.91162 8.29042 7.19963 7.8764 7.56685 7.52359C7.93407 7.17077 8.35889 6.89715 8.84131 6.70274C9.33094 6.50113 9.85656 6.40033 10.4182 6.40033C10.8358 6.40033 11.239 6.45793 11.6279 6.57314C12.0167 6.68834 12.3767 6.85035 12.7079 7.05916C13.0463 7.26797 13.3343 7.51999 13.572 7.8152L12.5135 8.86285C12.2399 8.52444 11.9231 8.26882 11.5631 8.09601C11.2102 7.92321 10.8286 7.8368 10.4182 7.8368C10.0798 7.8368 9.76296 7.90161 9.46774 8.03121C9.17253 8.15362 8.91692 8.32643 8.70091 8.54964C8.4849 8.76565 8.31569 9.02486 8.19328 9.32728C8.07087 9.62249 8.00967 9.94651 8.00967 10.2993C8.00967 10.6449 8.07087 10.969 8.19328 11.2714C8.31569 11.5666 8.4885 11.8258 8.71171 12.049C8.93492 12.265 9.19413 12.4342 9.48935 12.5566C9.79176 12.679 10.1194 12.7402 10.4722 12.7402C10.8682 12.7402 11.239 12.6574 11.5847 12.4918C11.9303 12.3262 12.2363 12.0886 12.5027 11.779L13.5287 12.7943C13.2911 13.0823 13.0067 13.3307 12.6755 13.5395C12.3443 13.7483 11.9843 13.9103 11.5955 14.0255C11.2138 14.1335 10.8214 14.1875 10.4182 14.1875Z" fill="#E3E6ED"/>
    </svg>
  </div>
</template>

<script>
import { gbKey } from '@/utils/growthbook';
import { logEvent } from '@/tarot_box/helper/native_api';

export default {
  name: "TarotDetailStartButton",

  inject: {
    growthbook: {
      from: gbKey,
      default: null
    }
  },

  props: {
    biggerPrice: {
      default: 0,
    },
    smallerPrice: {
      default: 0,
    },
  },

  emits: ['goTarotBoxInputPage'],

  data() {
    return {
      experiments: {
        buttonColor: null,
        buttonAnimation: null,
        buttonText: null,
        buttonImage: null,
      },

      defaultButtonText: {
        main: '시작하기',
        sub: '먼저 시작해보고 마지막에 결제해요'
      },
      colorName: '',
    };
  },

  computed: {
    buttonText() {
      return this.experiments.buttonText || this.defaultButtonText;
    },

    buttonTextStyle() {
      if (!this.experiments.buttonColor) return {};

      if (this.colorName === 'Teal'){
        return {
          color: 'white !important'
        };
      } else {
        return {
          color: 'black !important'
        };
      }
    },

    buttonSubTextStyle() {
      if (!this.experiments.buttonColor) return {
        fontSize: '12px',
        color: 'rgba(255,255,255,0.6)',
        fontWeight: '400'
      };

      if (this.colorName === 'Teal') {
        return {
          fontSize: '12px',
          color: 'rgba(255,255,255,0.6) !important',
          fontWeight: '400'
        };
      } else {
        return {
          fontSize: '12px',
          color: 'rgba(0,0,0,0.6) !important',
          fontWeight: '400'
        };
      }
    },

    buttonColorClass() {
      return '';
    },

    buttonColorStyle() {
      if (!this.experiments.buttonColor) return {};

      const colorConfig = this.experiments.buttonColor;

      if (colorConfig.type === 'gradient') {
        return {
          background: `linear-gradient(${colorConfig.direction || '45deg'}, ${colorConfig.colors.join(', ')})`,
        };
      }
      else if (colorConfig.type === 'solid' && colorConfig.color) {
        return {
          backgroundColor: colorConfig.color,
          color: 'white'
        };
      }

      return {};
    },

    buttonAnimationClass() {
      if (!this.experiments.buttonAnimation) return '';
      return `animation-${this.experiments.buttonAnimation.type}`;
    },
  },

  watch: {
    'growthbook.ready'(newVal) {
      if (newVal) {
        this.setupAllExperiments();
      }
    }
  },

  mounted() {
    this.setupAllExperiments();

    setTimeout(() => {
      this.logExperimentImpression();
    }, 1000);
  },

  methods: {
    setupAllExperiments() {
      if (!this.growthbook || !this.growthbook.ready) return;

      this.setupButtonColorExperiment();
      this.setupButtonAnimationExperiment();
      this.setupButtonTextExperiment();
      this.setupButtonImageExperiment();
    },

    setupButtonColorExperiment() {
      if (!this.growthbook || !this.growthbook.ready) return;

      const result = this.growthbook.feature('button-color-experiment');
      if (!result.on || !result.value) return;

      this.experiments.buttonColor = result.value.value;
      this.colorName = result.value.name;
    },

    setupButtonAnimationExperiment() {
      if (!this.growthbook || !this.growthbook.ready) return;

      const result = this.growthbook.feature('button-animation-experiment');
      console.log('result', result);
      if (!result.on || !result.value) return;

      this.experiments.buttonAnimation = result.value;
      console.log('2차 실험 - Button Animation:', result.value);
      console.log('2차 실험', this.experiments.buttonAnimation);
    },

    setupButtonTextExperiment() {
      const result = this.growthbook.feature('button-text-experiment');
      if (!result.on || !result.value) return;
      this.experiments.buttonText = result.value;
    },

    setupButtonImageExperiment() {
      const result = this.growthbook.feature('button-image-experiment');
      if (!result.on || !result.value) return;
      this.experiments.buttonImage = result.value;
    },

    logExperimentImpression() {
      const experimentMetadata = this.getExperimentMetadata();
      const colorExperimentData = {};

      if (this.experiments.buttonColor) {
        colorExperimentData.button_color_type = this.experiments.buttonColor.type;
      }

      logEvent('tarot_detail_start_button_impression', {
        ...experimentMetadata,
        ...colorExperimentData,
        button_platform: this.isWebPlatform() ? 'web' : 'app',
        button_animation: this.experiments.buttonAnimation?.type,
      });
    },

    getExperimentMetadata() {
      const metadata = {};

      Object.keys(this.experiments).forEach(expKey => {
        const featureName = `button-${expKey.replace('button', '').toLowerCase()}-experiment`;
        const result = this.growthbook.feature(featureName);

        if (result.experiment) {
          metadata[`${expKey}_experiment_id`] = result.experiment.key;
          metadata[`${expKey}_variation_id`] = result.experimentResult?.variationId;
        }
      });

      return metadata;
    },

    handleButtonClick() {
      const experimentMetadata = this.getExperimentMetadata();

      const colorExperimentData = {};
      if (this.experiments.buttonColor) {
        colorExperimentData.button_color_type = this.experiments.buttonColor.type;
        colorExperimentData.button_color_variant = this.experiments.buttonColor.variant;

        if (this.experiments.buttonColor.type === 'gradient') {
          colorExperimentData.gradient_colors_count = this.experiments.buttonColor.colors?.length || 0;
        }
      }

      const platformInfo = {
        button_platform: this.isWebPlatform() ? 'web' : 'app',
      };

      logEvent('tarot_detail_start_button_click', {
        ...experimentMetadata,
        ...colorExperimentData,
        ...platformInfo,
        button_color: this.experiments.buttonColor?.type,
        button_animation: this.experiments.buttonAnimation?.type,
        button_text: this.experiments.buttonText?.main,
        has_image: !!this.experiments.buttonImage,
        price: this.smallerPrice,
      });

      this.goTarotBoxInputPage();
    },

    isWebPlatform() {
      return true;
    },

    addCommaToPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    goTarotBoxInputPage() {
      this.$emit('goTarotBoxInputPage');
    },
  },
}
</script>

<style scoped>
/* 기본 레이아웃 스타일 */
.start-button {
  position: fixed;
  bottom: 0px;
  width: 100vw;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 16px 16px 16px;
  box-sizing: border-box;
  gap: 14px;
  background-color: var(--Grayscale-Gray12);
  border-top: 0.5px solid #C9CCD1;
  font-size: 18px;
  font-weight: 700;
  transition: transform 200ms ease-in-out;
}

.button-image-container {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.button-image-container img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.price {
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  text-align: left;
  flex: 1;
}

.bigger-price {
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 400;
  color: #B4B4B4;
  text-decoration: line-through;
}

.smaller-price {
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 18px;
  font-weight: 800;
  color: var(--Grayscale-Gray1);
}

.cta {
  flex: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100px;
  height: 100%;
  background-color: var(--Color-palette-Primary-Default);
  color: white;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.start-button2 {
  position: fixed;
  bottom: 0px;
  width: 100vw;
  height: 60px;
  background-color: var(--Color-palette-Primary-Default);
  color: var(--Grayscale-Gray12);
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 200ms ease-in-out;
}

.button-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.price2 {
  font-size: 16px;
  font-weight: 700;
  color: #4BD1A9;
  margin-left: 2px;
  margin-right: 2px;
}

.original-price2 {
  font-size: 16px;
  font-weight: 700;
  color: #207e62;
  margin-left: 10px;
  margin-right: 2px;
  text-decoration: line-through;
  text-decoration-thickness: 2px;
}

/* 2차 실험: 애니메이션 */

/* Slide-in 애니메이션 */
.animation-slide-in {
  animation: slide-in 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation-delay: 0.5s;
}

/* Heartbeat 애니메이션 */
.animation-heartbeat {
  animation: heartbeat 1.5s ease-in-out infinite;
}

/* Neon 애니메이션 */
.animation-neon {
  position: relative;
  overflow: hidden;
}

.animation-neon::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 8px;
  padding: 2px;
  background: linear-gradient(45deg, #03e9f4, #6B94FF, #03e9f4);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.3s;
}

.animation-neon:hover::before {
  opacity: 1;
}

.animation-neon:hover {
  box-shadow: 0 0 5px #03e9f4, 0 0 25px #03e9f4, 0 0 50px #03e9f4;
}

.animation-neon .neon-border {
  position: absolute;
  display: block;
}

.animation-neon .neon-border:nth-child(1) {
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #03e9f4);
  animation: neon-1 1s linear infinite;
}

.animation-neon .neon-border:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #03e9f4);
  animation: neon-2 1s linear infinite;
  animation-delay: 0.25s;
}

.animation-neon .neon-border:nth-child(3) {
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #03e9f4);
  animation: neon-3 1s linear infinite;
  animation-delay: 0.5s;
}

.animation-neon .neon-border:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #03e9f4);
  animation: neon-4 1s linear infinite;
  animation-delay: 0.75s;
}

/* Keyframes */
@keyframes slide-in {
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(0.91);
  }
  28% {
    transform: scale(0.98);
  }
  42% {
    transform: scale(0.87);
  }
  70% {
    transform: scale(1);
  }
}

@keyframes neon-1 {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

@keyframes neon-2 {
  0% { top: -100%; }
  50%, 100% { top: 100%; }
}

@keyframes neon-3 {
  0% { right: -100%; }
  50%, 100% { right: 100%; }
}

@keyframes neon-4 {
  0% { bottom: -100%; }
  50%, 100% { bottom: 100%; }
}
</style>